import apiService from './ApiService';

class ProcesosAsincronicosService {
  async importarProfesoresExcel({ idColegio, archivo }) {
    if (!idColegio) {
      throw new Error('No hay un colegio seleccionado para importar profesores.');
    }

    if (!archivo) {
      throw new Error('Debes seleccionar un archivo Excel.');
    }

    const formData = new FormData();
    formData.append('idColegio', idColegio);
    formData.append('archivo', archivo);

    const response = await apiService.post('/profesores/importar', formData);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear la solicitud de importación.';
      throw new Error(msg);
    }

    return response;
  }

  async importarAreasExcel({ idColegio, archivo }) {
    if (!idColegio) {
      throw new Error('No hay un colegio seleccionado para importar áreas.');
    }

    if (!archivo) {
      throw new Error('Debes seleccionar un archivo Excel.');
    }

    const formData = new FormData();
    formData.append('idColegio', idColegio);
    formData.append('archivo', archivo);

    const response = await apiService.post('/area/importar', formData);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear la solicitud de importación.';
      throw new Error(msg);
    }

    return response;
  }

  async importarMateriasExcel({ idColegio, archivo }) {
    if (!idColegio) {
      throw new Error('No hay un colegio seleccionado para importar materias.');
    }

    if (!archivo) {
      throw new Error('Debes seleccionar un archivo Excel.');
    }

    const formData = new FormData();
    formData.append('idColegio', idColegio);
    formData.append('archivo', archivo);

    const response = await apiService.post('/Materias/importar', formData);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear la solicitud de importación.';
      throw new Error(msg);
    }

    return response;
  }

  async importarCursosExcel({ idColegio, archivo }) {
    if (!idColegio) {
      throw new Error('No hay un colegio seleccionado para importar cursos.');
    }

    if (!archivo) {
      throw new Error('Debes seleccionar un archivo Excel.');
    }

    const formData = new FormData();
    formData.append('idColegio', idColegio);
    formData.append('archivo', archivo);

    const response = await apiService.post('/cursos/importar', formData);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear la solicitud de importación.';
      throw new Error(msg);
    }

    return response;
  }

  async importarAlumnosCursoExcel({ cursoId, idColegio, archivo }) {
    if (!cursoId) {
      throw new Error('No hay un curso seleccionado para importar alumnos.');
    }

    if (!idColegio) {
      throw new Error('No hay un colegio seleccionado para importar alumnos.');
    }

    if (!archivo) {
      throw new Error('Debes seleccionar un archivo Excel.');
    }

    const formData = new FormData();
    formData.append('idColegio', idColegio);
    formData.append('archivo', archivo);

    const response = await apiService.post(`/cursos/${cursoId}/importar-alumnos`, formData);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear la solicitud de importación.';
      throw new Error(msg);
    }

    return response;
  }

  async getProcesos(idColegio, options = {}) {
    const params = new URLSearchParams();
    if (idColegio) {
      params.set('colegioId', idColegio);
    }
    if (options.usarEsquemaPublico) {
      params.set('usarEsquemaPublico', 'true');
    }
    const qs = params.toString() ? `?${params.toString()}` : '';
    const response = await apiService.get(`/ProcesosAsincronicos${qs}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener las solicitudes.';
      throw new Error(msg);
    }

    return response;
  }

  async getProcesoDetalle(procesoId, idColegio, options = {}) {
    if (!procesoId) {
      throw new Error('Debes indicar un proceso.');
    }

    const params = new URLSearchParams();
    if (idColegio) {
      params.set('colegioId', idColegio);
    }
    if (options.usarEsquemaPublico) {
      params.set('usarEsquemaPublico', 'true');
    }
    const qs = params.toString() ? `?${params.toString()}` : '';
    const response = await apiService.get(`/ProcesosAsincronicos/${procesoId}${qs}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener el detalle del proceso.';
      throw new Error(msg);
    }

    return response;
  }
}

const procesosAsincronicosService = new ProcesosAsincronicosService();

export default procesosAsincronicosService;
